import { ref, computed, onBeforeUnmount, watch, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
let id = 0;
export default {
  props: {
    token: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      required: true
    },
    deleteToken: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  emits: ['change'],
  setup(props, {
    emit
  }) {
    const {
      t
    } = useI18n({
      useScope: 'global'
    });
    const selectRef = ref(`loanSelect${id += 1}`);
    const visible = ref(false);
    const searchToken = ref('');
    const filterData = computed(() => props.data?.filter(item => item.token !== props.deleteToken && item.token.includes(searchToken.value)));
    const popperOptions = {
      modifiers: [{
        name: 'flip',
        options: {
          // 默认为bottom-start，如果底部空间不够，则设置为top-start
          fallbackPlacements: ['top-start']
        }
      }]
    };
    const selectedValue = computed(() => {
      const [value] = props.data?.filter(item => item.token === props.token);
      return value;
    });
    const methods = {
      inputSearchToken(value) {
        searchToken.value = value.trim().toUpperCase();
      },
      handleSelect(item = {}) {
        emit('change', item.token);
      },
      handleBodyClick(e) {
        const cdom = document.querySelector(`#${selectRef.value}`);
        if (!cdom) {
          return;
        }
        if (cdom?.contains(e.target)) {
          visible.value = !visible.value;
        } else {
          visible.value = false;
        }
      }
    };
    watch(() => props.visible, value => {
      if (!value) {
        searchToken.value = '';
      }
    });
    onMounted(() => {
      document.querySelector('body')?.addEventListener('click', methods.handleBodyClick);
      document.querySelector('.el-dialog')?.addEventListener('click', methods.handleBodyClick);
    });
    onBeforeUnmount(() => {
      document.querySelector('body')?.removeEventListener('click', methods.handleBodyClick);
      document.querySelector('.el-dialog')?.removeEventListener('click', methods.handleBodyClick);
    });
    return {
      t,
      ...methods,
      filterData,
      searchToken,
      selectedValue,
      popperOptions,
      visible,
      selectRef
    };
  }
};